import { render, staticRenderFns } from "./AlbumMonthComponent.vue?vue&type=template&id=0746875d&scoped=true"
import script from "./AlbumMonthComponent.vue?vue&type=script&lang=js"
export * from "./AlbumMonthComponent.vue?vue&type=script&lang=js"
import style0 from "./AlbumMonthComponent.vue?vue&type=style&index=0&id=0746875d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0746875d",
  null
  
)

export default component.exports